import { createSelector } from 'reselect';

export const getAccessToken = state => state.auth.token.access;
export const getRefreshToken = state => state.auth.token.refresh;
export const getIsProviderToken = state => state.auth.token.isProviderToken;

const isTokenExpired = (token) => {
    try {
        const payload = JSON.parse(atob(token.split('.')[1]));
        return payload.exp * 1000 < Date.now();
    } catch {
        return true;
    }
};

export const accessTokenSelector = createSelector(
    getAccessToken,
    getRefreshToken,
    (access, refresh) => {
        if (!access || !refresh) return null;
        // Si el refresh expiró, los tokens son inválidos — no exponer el access token
        if (isTokenExpired(refresh)) return null;
        return access;
    }
);
export const refreshTokenSelector = createSelector(getRefreshToken, refresh => refresh);
export const isProviderTokenSelector = createSelector(getIsProviderToken, state => state);

export const validTokensSelector = createSelector(
    getAccessToken,
    getRefreshToken,
    (accessToken, refreshToken) => {
        if (!accessToken || !refreshToken) return false;
        if (isTokenExpired(refreshToken)) return false;
        return true;
    }
);
